import { ShimmerMetricRow, ShimmerTwoCol } from "./DashboardShimmer";

import "./dashboard-sections.css";

const DashboardSummaryBox = ({data:m ,index})=>{

    return (  
        <div key={index} className="db-metric-card">
            <div className="db-metric-label">{m.label}</div>
            <div className={`db-metric-value${m.danger ? " danger" : ""}`}>
            {m.value}
            {m.unit && <span className="db-metric-unit">{m.unit}</span>}
            {m.badge && <span className="db-metric-badge">{m.badge}</span>}
            {m.dot && <span className="db-metric-dot" />}
            </div>
        </div>
    );
}

export default DashboardSummaryBox;